import React from 'react';

const FlowChartSidebar = ({
  isDesignMode,
  requestFiles,
  fileSearchQuery,
  setFileSearchQuery,
  selectedFileCategory,
  setSelectedFileCategory,
  tabs,
  activeTabId,
  handleFileClick,
  workflowData,
}) => {
  if (!isDesignMode) return null;

  const activeTab = tabs.find((t) => t.id === activeTabId);
  const activeWorkflowId = activeTab?.workflowData?.workflow?.id;
  const reqId = workflowData?.REQID || activeTab?.file?.REQID || requestFiles?.[0]?.REQID || '';

  const uniqueFolders = requestFiles
    ? [...new Set(requestFiles.map((f) => f.folder).filter(Boolean))]
    : [];

  const filteredFiles = (requestFiles || []).filter((file) => {
    const matchesSearch =
      !fileSearchQuery ||
      file.name.toLowerCase().includes(fileSearchQuery.toLowerCase()) ||
      (file.folder && file.folder.toLowerCase().includes(fileSearchQuery.toLowerCase()));
    const matchesCategory = selectedFileCategory === 'all' || file.folder === selectedFileCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div
      style={{
        width: 230,
        minWidth: 230,
        flexShrink: 0,
        background: '#1e1e1e',
        borderRight: '1px solid #2d2d2d',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* ── Logo + REQID ── */}


      {/* ── Files Section ── */}
      {requestFiles && requestFiles.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
          {/* REQID */}
          {reqId && (
            <div style={{
              padding: '8px 12px 4px',
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              flexShrink: 0,
            }}>
              <span style={{ color: '#484f58', fontSize: 9, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>REQ</span>
              <span style={{ color: '#58a6ff', fontSize: 10, fontWeight: 600, fontFamily: "'Fira Mono', monospace", letterSpacing: '0.02em' }}>
                {String(reqId)}
              </span>
            </div>
          )}

          {/* Header */}
          <div style={{
            padding: '4px 12px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}>
            <span style={{ color: '#8b949e', fontSize: 9, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Files
            </span>
            <span style={{ color: '#484f58', fontSize: 9 }}>{filteredFiles.length}</span>
          </div>

          {/* Search */}
          <div style={{ padding: '6px 12px', flexShrink: 0 }}>
            <div style={{ position: 'relative' }}>
              <svg
                width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#484f58" strokeWidth="2.5"
                style={{ position: 'absolute', left: 7, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
              >
                <circle cx="11" cy="11" r="7" />
                <line x1="16.5" y1="16.5" x2="21" y2="21" />
              </svg>
              <input
                type="text"
                placeholder="Ara..."
                value={fileSearchQuery}
                onChange={(e) => setFileSearchQuery(e.target.value)}
                style={{
                  width: '100%',
                  padding: '5px 8px 5px 24px',
                  background: '#161b22',
                  border: '1px solid #30363d',
                  borderRadius: 5,
                  color: '#c9d1d9',
                  fontSize: 10,
                  outline: 'none',
                  transition: 'border-color 0.15s',
                  boxSizing: 'border-box',
                }}
                onFocus={(e) => { e.currentTarget.style.borderColor = '#388bfd'; }}
                onBlur={(e) => { e.currentTarget.style.borderColor = '#30363d'; }}
              />
            </div>
          </div>

          {/* Folder Tabs */}
          {uniqueFolders.length > 0 && (
            <div style={{ padding: '0 12px 6px', display: 'flex', gap: 3, flexWrap: 'wrap', flexShrink: 0 }}>
              <button
                onClick={() => setSelectedFileCategory('all')}
                style={{
                  padding: '2px 7px',
                  background: selectedFileCategory === 'all' ? '#388bfd' : 'transparent',
                  border: selectedFileCategory === 'all' ? '1px solid #388bfd' : '1px solid #30363d',
                  borderRadius: 10,
                  color: selectedFileCategory === 'all' ? '#fff' : '#8b949e',
                  fontSize: 9,
                  cursor: 'pointer',
                  transition: 'all 0.12s',
                  fontWeight: selectedFileCategory === 'all' ? 600 : 400,
                }}
              >
                Tümü
              </button>
              {uniqueFolders.map((folder) => (
                <button
                  key={folder}
                  onClick={() => setSelectedFileCategory(folder)}
                  style={{
                    padding: '2px 7px',
                    background: selectedFileCategory === folder ? '#388bfd' : 'transparent',
                    border: selectedFileCategory === folder ? '1px solid #388bfd' : '1px solid #30363d',
                    borderRadius: 10,
                    color: selectedFileCategory === folder ? '#fff' : '#8b949e',
                    fontSize: 9,
                    cursor: 'pointer',
                    transition: 'all 0.12s',
                    fontWeight: selectedFileCategory === folder ? 600 : 400,
                  }}
                >
                  {folder}
                </button>
              ))}
            </div>
          )}

          {/* File List */}
          <div style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '0 8px 8px',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
            {filteredFiles.length === 0 ? (
              <div style={{ padding: 16, textAlign: 'center', color: '#484f58', fontSize: 10 }}>
                Dosya bulunamadı
              </div>
            ) : (
              filteredFiles.map((file, index) => {
                const isActiveTab =
                  activeTab?.fileId === file.diagrun_id ||
                  (activeTab?.fileId == null && activeWorkflowId && String(activeWorkflowId) === String(file.diagrun_id));

                const isFileOpen = tabs.some((tab) => tab.fileId === file.diagrun_id);

                return (
                  <div
                    key={file.diagrun_id || index}
                    onClick={async () => {
                      if (!handleFileClick) return;
                      try { await handleFileClick(file); } catch (err) { /* */ }
                    }}
                    style={{
                      padding: '6px 8px',
                      background: isActiveTab
                        ? 'linear-gradient(90deg, #0e639c22, #0e639c11)'
                        : 'transparent',
                      borderRadius: 4,
                      fontSize: 10,
                      color: '#c9d1d9',
                      cursor: 'pointer',
                      borderLeft: isActiveTab
                        ? '2px solid #388bfd'
                        : isFileOpen
                          ? '2px solid #3fb95044'
                          : '2px solid transparent',
                      transition: 'all 0.12s',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 7,
                    }}
                    title={`${file.name}${file.folder ? ` — ${file.folder}` : ''}${isActiveTab ? ' (Aktif)' : ''}`}
                    onMouseEnter={(e) => {
                      if (!isActiveTab) {
                        e.currentTarget.style.background = '#ffffff08';
                        e.currentTarget.style.borderLeftColor = '#388bfd55';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActiveTab) {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.borderLeftColor = isFileOpen ? '#3fb95044' : 'transparent';
                      }
                    }}
                  >
                    {/* File icon */}
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={isActiveTab ? '#58a6ff' : '#484f58'} strokeWidth="1.8" style={{ flexShrink: 0 }}>
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>

                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <div style={{
                        fontWeight: isActiveTab ? 600 : 400,
                        color: isActiveTab ? '#e6edf3' : '#c9d1d9',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: 10.5,
                        lineHeight: 1.3,
                      }}>
                        {file.name}
                      </div>
                      {file.folder && (
                        <div style={{ fontSize: 8.5, color: '#484f58', lineHeight: 1.2 }}>
                          {file.folder}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FlowChartSidebar;
